
export default "/assets/document-arrow-up-micro.a4cec46a.svg"